import { render } from "./GameBetHistory.vue?vue&type=template&id=908249ca&ts=true"
import script from "./GameBetHistory.vue?vue&type=script&lang=ts"
export * from "./GameBetHistory.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__